const ImageIcon = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="21"
		viewBox="0 0 20 21"
		fill="none"
		{...props}
	>
		<path
			d="M20 19.054H0V1.104H20V19.054ZM1.33683 17.7168H18.6629V2.44115H1.33683V17.7168Z"
			fill="black"
		/>
		<path
			d="M6.40145 9.13737C7.52925 9.13737 8.44352 8.2231 8.44352 7.0953C8.44352 5.96749 7.52925 5.05322 6.40145 5.05322C5.27364 5.05322 4.35938 5.96749 4.35938 7.0953C4.35938 8.2231 5.27364 9.13737 6.40145 9.13737Z"
			fill="black"
		/>
		<path
			d="M14.9726 7.88491C14.274 8.05606 11.5673 10.0388 9.31028 12.4574C9.78372 12.9337 10.2384 13.5853 10.6331 14.4839L7.43555 15.9116V16.5232H17.6231V9.06107C16.9931 8.41266 16.1637 7.59214 14.9726 7.88491Z"
			fill="black"
		/>
		<path
			d="M9.88827 16.5235C9.89176 16.446 9.90001 16.3695 9.90001 16.291C9.90001 13.4843 6.25502 11.2104 4.9074 11.2104C4.35425 11.2104 3.09744 11.836 2.37695 12.6895V16.5235H9.88827Z"
			fill="black"
		/>
	</svg>
);

export default ImageIcon;
